<template>
  <div class="content">
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV">
      <img src="@/assets/images/inicio.png">
      Inicio
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/user-management" v-if="permissionGestionUsuarios">
      <img src="@/assets/images/item-menu-gestion-usuario.png">
      Gestión de Usuarios
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" :to="type === 'Superadministrador' ? '/SGCCV/despachos' : '/SGCCV/workplaces'" v-if="permissionGestionDespacho || type === 'Superadministrador'">
      <img src="@/assets/images/item-menu-gestion-despacho.png">
      Gestión de Despacho
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/management" v-if="permissionGestiones">
      <img src="@/assets/images/item-menu-gestiones.png">
      Gestiones
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/calendar" v-if="permissionCalendario">
      <img src="@/assets/images/item-menu-calendario.png">
      Calendario
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/projectTracking" v-if="permissionSeguimiento">
      <img src="@/assets/images/item-menu-seguimiento.png">
      Seguimiento
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/reports" v-if="permissionReportes">
      <img src="@/assets/images/item-menu-reporte.png">
      Reportes
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/debtor-fields" v-if="type == 'Superadministrador'">
      <img src="@/assets/images/item-menu-reporte.png">
      Campos del Deudor
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/documents" v-if="permissionDocumentacion">
      <img src="@/assets/images/item-menu-documentacion.png">
      Documentación
    </router-link>    
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/notices" v-if="permissionAvisos">
      <img src="@/assets/images/item-menu-avisos.png">
      Avisos
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/graficas" v-if="permissionEstadistica">
      <img src="@/assets/images/item-menu-estadistica.png">
      Estadística
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/groups" v-if="permissionGrupos">
      <img src="@/assets/images/item-menu-grupos.png">
      Grupos
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/database" v-if="permissionBaseDatos">
      <img src="@/assets/images/item-menu-base-datos.png">
      Base de Datos
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/database/imports" v-if="permissionBaseDatos">
      <img src="@/assets/images/item-menu-base-datos.png">
      Base de Datos 2.0
    </router-link>
    <!--  <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/empty" v-if="permissionGestionesMasivas">
      <img src="@/assets/images/item-menu-gestiones-masivas.png">
      Gestiones Masivas
    </router-link> -->    
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/minutas" v-if="permissionMinutas">
      <img src="@/assets/images/item-menu-minuta.png">
      Mínutas
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/carrusel" v-if="type == 'Administrador'">
      <img src="@/assets/images/periodico.png">
      Noticias
    </router-link>
    <router-link activeClass="item_selected_menu" class="item_menu" to="/SGCCV/bitacora" v-if="type == 'Administrador'">
      <img src="@/assets/images/bitacora.png">
      Bitacora
    </router-link>
    <div activeClass="item_selected_menu" class="item_menu" v-on:click="logout()">
      <img src="@/assets/images/item-menu-cerrar-sesion.png">
      Cerrar Sesión
    </div>
  </div>
</template>

<script>

  import { EncryptService } from '@/services/EncryptService'
  import { useUiStore } from '@/stores/ui'
  import { useAuthStore } from '@/stores/auth'

  export default {
      name: 'MenuComponent',
      props: {
        msg: String
      },
      data: () => ({
        type: '',
        arrPermission: [],
        permissionAvisos: false,
        permissionReportes: false,
        permissionSeguimiento: false,
        permissionDocumentacion: false,
        permissionGestionUsuarios: false,
        permissionGestionDespacho: false,
        permissionGrupos: false,
        permissionCalendario: false,
        permissionBaseDatos: false,
        permissionGestionesMasivas: false,
        permissionEstadistica: false,
        permissionGestiones: false,
        permissionMinutas: false,
      }),
      async mounted() {
        await this.checkType();
        this.checkPermissions();
      },
      methods: {
        logout: function() {          
          const uiStore = useUiStore()
          const authStore = useAuthStore()
          uiStore.limpiar()
          authStore.logout()

          localStorage.removeItem('ID')
          localStorage.removeItem('TIPO')
          localStorage.removeItem('TOKEN')
          localStorage.removeItem('DESPACHO')
          localStorage.removeItem('USERNAME')
          localStorage.removeItem('NAME')
          localStorage.removeItem('LAST_NAME')
          sessionStorage.removeItem('ISABELLE_PHONE')
          localStorage.removeItem('TIPO_CARTERA')
          
          this.$router.push('/login')
        },
        checkType: async function () {
          const ENC_TYPE = localStorage.getItem('TIPO')
          const DEC_TYPE = await EncryptService.decrypt(ENC_TYPE)
          this.type = DEC_TYPE;
        },
        checkPermissions: async function () {

          const ENC_PERMISOS = localStorage.getItem('PERMISOS')
          const STR_PERMISOS = atob(ENC_PERMISOS)
          this.arrPermission = JSON.parse(STR_PERMISOS)
          
          for (const element of this.arrPermission) {
            if (element.modulo === 'M01AVIS' && element.permiso > 0) {
              this.permissionAvisos = true;
            }
            if (element.modulo === 'M02REPO' && element.permiso > 0) {
              this.permissionReportes = true;
            }
            if (element.modulo === 'M03SEGU' && element.permiso > 0) {
              this.permissionSeguimiento = true;
            }
            if (element.modulo === 'M04DOCU' && element.permiso > 0) {
              this.permissionDocumentacion = true;
            }
            if (element.modulo === 'M05GEUS' && element.permiso > 0) {
              this.permissionGestionUsuarios = true;
            }
            if (element.modulo === 'M06GEDE' && element.permiso > 0) {
              this.permissionGestionDespacho = true;
            }
            if (element.modulo === 'M07GRUP' && element.permiso > 0) {
              this.permissionGrupos = true;
            }
            if (element.modulo === 'M08CALE' && element.permiso > 0) {
              this.permissionCalendario = true;
            }
            if (element.modulo === 'M09BADA' && element.permiso > 0) {
              this.permissionBaseDatos = true;
            }
            if (element.modulo === 'M11ESTA' && element.permiso > 0) {
              this.permissionEstadistica = true;
            }
            if (element.modulo === 'M12GEST' && element.permiso > 0) {
              this.permissionGestiones = true;
            }
            if (element.modulo === 'M13MIRE' && element.permiso > 0) {
              this.permissionMinutas = true;
            }
          }  
        }
      }
  }
</script>

<style scoped>
  .content {
    width: 60px;
    height: 81vh;
    display: flex;
    flex-direction: column;
    transition: 0.2s;
    padding: 8px 0;
    border-right: 1px solid #CDCDCD;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .content:hover {
    width: 260px;
  }

  .item_menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    margin: 5px 10px;
    border-radius: 5px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 10pt;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    color: #131313;
  }
  .item_menu:hover {
    background-color: #D9D9D9;
    color: #000000;
    font-weight: 600;
  }
  .item_menu img {
    max-width: 30px;
    max-height: 30px;
    margin-left: 10px;
    margin-right: 20px;
  }

  .logo_menu {
    background-color: #B8B8B8;
    width: 240px;
    height: 240px;
    margin: 10px;
  }

  .item_selected_menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    margin: 5px 10px;
    border-radius: 5px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 10pt;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    background-color: #D9D9D9;
    color: #000000;
    font-weight: 600;
  }
</style>